import React, { useEffect, useRef, useState } from "react";
import {
  ChatOutline,
  ChevronLeft,
  ChevronLeftMini,
  ChevronRight,
  ChevronRightMini,
  FilterMini,
} from "../assets/SvgIcons";
import { Link } from "react-router-dom";
import BasicSelectInput from "../components/FormComponent/BasicSelectInput";
import SortInput from "../components/FormComponent/SortInput";
import FilterInput from "../components/FormComponent/FilterInput";

const premiumSupplier = [
  {
    brand: "Dummy Brand 1",
    image:
      "https://main.d2qfb7a0oc8xva.amplifyapp.com/static/media/9.13f6f2f51394552b0d2c0a8415beee8b.svg",
    link: "/supplier/details/1",
    location: "New York, USA",
    isPremium: true,
  },
  {
    brand: "Dummy Brand 2",
    image:
      "https://main.d2qfb7a0oc8xva.amplifyapp.com/static/media/9.13f6f2f51394552b0d2c0a8415beee8b.svg",
    link: "/supplier/details/2",
    location: "London, UK",
    isPremium: true,
  },
  {
    brand: "Dummy Brand 3",
    image:
      "https://main.d2qfb7a0oc8xva.amplifyapp.com/static/media/9.13f6f2f51394552b0d2c0a8415beee8b.svg",
    link: "/supplier/details/3",
    location: "Tokyo, Japan",
    isPremium: true,
  },
  {
    brand: "Dummy Brand 4",
    image:
      "https://main.d2qfb7a0oc8xva.amplifyapp.com/static/media/9.13f6f2f51394552b0d2c0a8415beee8b.svg",
    link: "/supplier/details/4",
    location: "Berlin, Germany",
    isPremium: true,
  },
];

const supplierData = [
  {
    brand: "Dummy Brand 1",
    image:
      "https://main.d2qfb7a0oc8xva.amplifyapp.com/static/media/9.13f6f2f51394552b0d2c0a8415beee8b.svg",
    link: "/supplier/details/1",
    location: "New York, USA",
    isPremium: true,
  },
  {
    brand: "Dummy Brand 2",
    image:
      "https://main.d2qfb7a0oc8xva.amplifyapp.com/static/media/9.13f6f2f51394552b0d2c0a8415beee8b.svg",
    link: "/supplier/details/2",
    location: "London, UK",
    isPremium: true,
  },
  {
    brand: "Dummy Brand 3",
    image:
      "https://main.d2qfb7a0oc8xva.amplifyapp.com/static/media/9.13f6f2f51394552b0d2c0a8415beee8b.svg",
    link: "/supplier/details/3",
    location: "Tokyo, Japan",
    isPremium: true,
  },
  {
    brand: "Dummy Brand 4",
    image:
      "https://main.d2qfb7a0oc8xva.amplifyapp.com/static/media/9.13f6f2f51394552b0d2c0a8415beee8b.svg",
    link: "/supplier/details/4",
    location: "Berlin, Germany",
    isPremium: true,
  },
  {
    brand: "Dummy Brand 5",
    image:
      "https://main.d2qfb7a0oc8xva.amplifyapp.com/static/media/9.13f6f2f51394552b0d2c0a8415beee8b.svg",
    link: "/supplier/details/5",
    location: "Paris, France",
  },
  {
    brand: "Dummy Brand 6",
    image:
      "https://main.d2qfb7a0oc8xva.amplifyapp.com/static/media/9.13f6f2f51394552b0d2c0a8415beee8b.svg",
    link: "/supplier/details/6",
    location: "Sydney, Australia",
  },
  {
    brand: "Dummy Brand 7",
    image:
      "https://main.d2qfb7a0oc8xva.amplifyapp.com/static/media/9.13f6f2f51394552b0d2c0a8415beee8b.svg",
    link: "/supplier/details/7",
    location: "Los Angeles, USA",
  },
  {
    brand: "Dummy Brand 8",
    image:
      "https://main.d2qfb7a0oc8xva.amplifyapp.com/static/media/9.13f6f2f51394552b0d2c0a8415beee8b.svg",
    link: "/supplier/details/8",
    location: "Milan, Italy",
  },
  {
    brand: "Dummy Brand 6",
    image:
      "https://main.d2qfb7a0oc8xva.amplifyapp.com/static/media/9.13f6f2f51394552b0d2c0a8415beee8b.svg",
    link: "/supplier/details/6",
    location: "Sydney, Australia",
  },
  {
    brand: "Dummy Brand 7",
    image:
      "https://main.d2qfb7a0oc8xva.amplifyapp.com/static/media/9.13f6f2f51394552b0d2c0a8415beee8b.svg",
    link: "/supplier/details/7",
    location: "Los Angeles, USA",
  },
  {
    brand: "Dummy Brand 8",
    image:
      "https://main.d2qfb7a0oc8xva.amplifyapp.com/static/media/9.13f6f2f51394552b0d2c0a8415beee8b.svg",
    link: "/supplier/details/8",
    location: "Milan, Italy",
  },
];

const Supplier = () => {
  return (
    <>
      <SupplierCardRow SupplierType={"Premium Supplier"} />
      <SupplierCardGrid SupplierType={"All Supplier"} />
    </>
  );
};

export default Supplier;

const SupplierCardRow = ({ SupplierType }) => {
  const scrollRef = useRef(null);
  const [cardWidth, setCardWidth] = useState(280);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(true);

  const checkScrollPosition = () => {
    if (scrollRef.current) {
      const { scrollLeft, scrollWidth, clientWidth } = scrollRef.current;
      setCanScrollLeft(scrollLeft > 0);
      setCanScrollRight(scrollLeft + clientWidth < scrollWidth);
    }
  };

  useEffect(() => {
    checkScrollPosition(); // initial check on load
    const currentScrollRef = scrollRef.current; // Store current reference

    if (currentScrollRef) {
      currentScrollRef.addEventListener("scroll", checkScrollPosition);
    }

    return () => {
      // Cleanup: check if currentScrollRef is valid
      if (currentScrollRef) {
        currentScrollRef.removeEventListener("scroll", checkScrollPosition);
      }
    };
  }, []);

  useEffect(() => {
    // Function to update cardWidth based on screen size
    const updateCardWidth = () => {
      const screenWidth = window?.innerWidth;
      if (screenWidth < 360) {
        setCardWidth(180);
      } else {
        setCardWidth(280);
      }
    };

    // Initial check
    updateCardWidth();

    // Listen to window resize
    window.addEventListener("resize", updateCardWidth);

    // Cleanup event listener on component unmount
    return () => window.removeEventListener("resize", updateCardWidth);
  }, []);

  return (
    <section className="">
      <div className="max-w-[1200px] mx-auto lg:px-2 md:px-4 sm:px-2 lg:py-16 md:py-14 sm:py-12">
        <h2 className="lg:text-3xl md:text-2xl sm:text-xl mb-6 ">
          {SupplierType || null}
        </h2>

        <div className="flex items-center w-full mb-12">
          <button
            onClick={() => {
              scrollRef.current.scrollBy({
                left: -1 * (cardWidth + 16),
                behavior: "smooth",
              });
            }}
            className={
              canScrollLeft
                ? "h-[56px] w-[56px] opacity-5 hover:opacity-100 transition-all ease-in-out flex justify-center items-center bg-[#fff] shadow-lg rounded-lg mr-[-56px] z-10"
                : "opacity-5 h-[56px] w-[56px]  transition-all ease-in-out flex justify-center items-center bg-[#fff] shadow-lg rounded-lg mr-[-56px] z-10"
            }
          >
            {ChevronLeftMini}
          </button>
          <div
            ref={scrollRef}
            className="w-full grid lg:grid-cols-4 md:grid-cols-2 sm:grid-cols-2  overflow-scroll gap-4 no-scrollbar "
          >
            {premiumSupplier?.map((supplier, index) => {
              return <SupplierCard key={index} supplier={supplier} />;
            })}
          </div>
          <button
            onClick={() => {
              // const maxScrollLeft =
              //   scrollRef.current.scrollWidth - scrollRef.current.clientWidth;
              scrollRef.current.scrollBy({
                left: cardWidth + 16,
                behavior: "smooth",
              });
            }}
            className={
              canScrollRight
                ? "h-[56px] w-[56px] opacity-5 hover:opacity-100 transition-all ease-in-out flex justify-center items-center bg-[#fff] shadow-lg rounded-lg ml-[-56px] z-10"
                : "opacity-5 h-[56px] w-[56px]  transition-all ease-in-out flex justify-center items-center bg-[#fff] shadow-lg rounded-lg ml-[-56px] z-10"
            }
          >
            {ChevronRightMini}
          </button>
        </div>
      </div>
    </section>
  );
};

const SupplierCardGrid = ({ SupplierType }) => {
  const [formData, setFormData] = useState({
    rating: "",
    country: "",
    city: "",
    sort: "",
  });

  const handleChangeFormData = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };
  return (
    <section className="">
      <div className="max-w-[1200px] mx-auto lg:px-2 md:px-4 sm:px-2 lg:pb-16 md:pb-14 sm:pb-12">
        <h2 className="lg:text-3xl md:text-2xl sm:text-xl mb-2 ">
          {SupplierType || null}
        </h2>
        <div className="flex justify-between items-center mb-4">
          <div className="flex justify-center items-center gap-2">
            {/* <p className="flex jutify-center items-center gap-2 text-[18px] font-semibold text-[#0297B2]">
              {FilterMini} Filter:
            </p> */}
            <p className="lg:block md:block sm:hidden text-[18px] font-semibold text-[#0297B2]">
              Filter:
            </p>
            <FilterInput
              // label={"Sort: "}
              name={"country"}
              onChange={handleChangeFormData}
              value={formData.country}
              options={["UAE", "Saudi Arabia", "Qatar", "USA", "UK"]}
              defaultDisabledValue={"Country"}
            />
            <FilterInput
              // label={"Sort: "}
              name={"city"}
              onChange={handleChangeFormData}
              value={formData.city}
              options={["Dubai", "Abu Dhabi", "Sharjah", "Ajman", "Fujairah"]}
              defaultDisabledValue={"City"}
            />
            <FilterInput
              // label={"Sort: "}
              name={"rating"}
              onChange={handleChangeFormData}
              value={formData.rating}
              options={["5 Star", "4 Star", "3 Star", "2 Star", "1 Star"]}
              defaultDisabledValue={"Rating"}
            />
          </div>
          <div className="lg:block md:block sm:hidden">
            <SortInput
              label={"Sort by: "}
              name={"sort"}
              onChange={handleChangeFormData}
              value={formData.sort}
              options={["High to Low", "Low to High"]}
              // defaultDisabledValue={"UAE"}
            />
          </div>
        </div>

        <div className="mx-auto w-full mb-12">
          <div className="w-full grid lg:grid-cols-4 md:grid-cols-2 sm:grid-cols-2 gap-4 mb-12">
            {supplierData?.map((supplier, index) => {
              return <SupplierCard key={index} supplier={supplier} />;
            })}
          </div>
          <Pagination
            currentPage={1}
            totalPages={1707}
            onPageChange={(page) => console.log("Selected Page:", page)}
            pageSize={30}
            onPageSizeChange={(size) =>
              console.log("Selected Page Size:", size)
            }
          />
        </div>
      </div>
    </section>
  );
};

const SupplierCard = ({ supplier }) => {
  return (
    <Link
      to={supplier?.link}
      className="shadow-sm mx-auto border bg-primarylight rounded-lg flex flex-col "
    >
      {supplier?.isPremium && (
        <div className="flex justify-center items-center gap-1 absolute px-2 py-1 bg-[#0297b2] m-2 rounded text-white text-[14px]">
          Premium
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="size-5"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M9 12.75 11.25 15 15 9.75M21 12c0 1.268-.63 2.39-1.593 3.068a3.745 3.745 0 0 1-1.043 3.296 3.745 3.745 0 0 1-3.296 1.043A3.745 3.745 0 0 1 12 21c-1.268 0-2.39-.63-3.068-1.593a3.746 3.746 0 0 1-3.296-1.043 3.745 3.745 0 0 1-1.043-3.296A3.745 3.745 0 0 1 3 12c0-1.268.63-2.39 1.593-3.068a3.745 3.745 0 0 1 1.043-3.296 3.746 3.746 0 0 1 3.296-1.043A3.746 3.746 0 0 1 12 3c1.268 0 2.39.63 3.068 1.593a3.746 3.746 0 0 1 3.296 1.043 3.746 3.746 0 0 1 1.043 3.296A3.745 3.745 0 0 1 21 12Z"
            />
          </svg>
        </div>
      )}
      <img
        src={supplier?.image}
        className="mx-auto rounded-t-lg lg:min-w-[280px] sm:min-w-[150px] "
        alt=""
      />

      <div className="lg:px-6 sm:px-3 pb-2 pt-4 flex justify-between items-center gap-4">
        <div className="">
          <h4 className="text-[13px]">{supplier?.brand}</h4>
          <h3 className="font-semibold text-[14px]">{supplier?.location}</h3>
          {supplier?.price && (
            <h3 className=" text-[14px]">from {supplier?.price}</h3>
          )}
        </div>
        <button>{ChatOutline} </button>
      </div>

      <div className="lg:px-5 sm:px-3 mb-2 flex justify-between items-center text-[14px]">
        <p className="flex items-center gap-1" title="4.9 out of 5 stars">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="black"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="size-5"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M11.48 3.499a.562.562 0 0 1 1.04 0l2.125 5.111a.563.563 0 0 0 .475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 0 0-.182.557l1.285 5.385a.562.562 0 0 1-.84.61l-4.725-2.885a.562.562 0 0 0-.586 0L6.982 20.54a.562.562 0 0 1-.84-.61l1.285-5.386a.562.562 0 0 0-.182-.557l-4.204-3.602a.562.562 0 0 1 .321-.988l5.518-.442a.563.563 0 0 0 .475-.345L11.48 3.5Z"
            />
          </svg>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="black"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="size-5"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M11.48 3.499a.562.562 0 0 1 1.04 0l2.125 5.111a.563.563 0 0 0 .475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 0 0-.182.557l1.285 5.385a.562.562 0 0 1-.84.61l-4.725-2.885a.562.562 0 0 0-.586 0L6.982 20.54a.562.562 0 0 1-.84-.61l1.285-5.386a.562.562 0 0 0-.182-.557l-4.204-3.602a.562.562 0 0 1 .321-.988l5.518-.442a.563.563 0 0 0 .475-.345L11.48 3.5Z"
            />
          </svg>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="black"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="size-5"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M11.48 3.499a.562.562 0 0 1 1.04 0l2.125 5.111a.563.563 0 0 0 .475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 0 0-.182.557l1.285 5.385a.562.562 0 0 1-.84.61l-4.725-2.885a.562.562 0 0 0-.586 0L6.982 20.54a.562.562 0 0 1-.84-.61l1.285-5.386a.562.562 0 0 0-.182-.557l-4.204-3.602a.562.562 0 0 1 .321-.988l5.518-.442a.563.563 0 0 0 .475-.345L11.48 3.5Z"
            />
          </svg>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="black"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="size-5"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M11.48 3.499a.562.562 0 0 1 1.04 0l2.125 5.111a.563.563 0 0 0 .475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 0 0-.182.557l1.285 5.385a.562.562 0 0 1-.84.61l-4.725-2.885a.562.562 0 0 0-.586 0L6.982 20.54a.562.562 0 0 1-.84-.61l1.285-5.386a.562.562 0 0 0-.182-.557l-4.204-3.602a.562.562 0 0 1 .321-.988l5.518-.442a.563.563 0 0 0 .475-.345L11.48 3.5Z"
            />
          </svg>
          4.3 ( 78 )
        </p>
      </div>
    </Link>
  );
};
const Pagination = ({
  currentPage,
  totalPages,
  onPageChange,
  pageSize,
  onPageSizeChange,
}) => {
  const pageSizes = [30, 60, 120];
  const maxPageLinks = 5; // number of page links to show before ellipsis
  const startPage = Math.max(currentPage - Math.floor(maxPageLinks / 2), 1);
  const endPage = Math.min(startPage + maxPageLinks - 1, totalPages);

  return (
    <nav className="flex items-center justify-between text-sm">
      {/* Page Size Selector */}
      <div className="lg:flex md:flex sm:hidden  gap-2 items-center">
        <div className="flex gap-2 items-center">
          {pageSizes.map((size) => (
            <div key={size}>
              {size === pageSize ? (
                <span className="px-3 h-[32px] bg-primary text-white flex items-center rounded">
                  {size}
                </span>
              ) : (
                <button
                  onClick={() => onPageSizeChange(size)}
                  className="px-3 h-[32px] bg-primarylight  flex items-center  rounded"
                >
                  {size}
                </button>
              )}
            </div>
          ))}
        </div>
      </div>

      {/* Pagination Links */}
      <div className="lg:mx-0 md:mx-0 sm:mx-auto flex gap-2 justify-center items-center">
        {/* Previous Button */}
        <div>
          {currentPage > 1 ? (
            <button
              onClick={() => onPageChange(currentPage - 1)}
              className="px-3 h-[32px]  rounded flex items-center"
              aria-label="Previous page"
            >
              {ChevronLeft}
            </button>
          ) : (
            <span className="px-3 h-[32px]  rounded cursor-not-allowed flex items-center">
              {ChevronLeft}
            </span>
          )}
        </div>

        {/* Page Numbers */}
        {[...Array(endPage - startPage + 1)].map((_, idx) => {
          const page = startPage + idx;
          return (
            <div key={page} className="flex items-center">
              {page === currentPage ? (
                <span className="px-3 h-[32px] bg-primary text-white  flex items-center  rounded">
                  {page}
                </span>
              ) : (
                <button
                  onClick={() => onPageChange(page)}
                  className="px-3 h-[32px] bg-primarylight  flex items-center  rounded"
                  aria-label={`Page ${page}`}
                >
                  {page}
                </button>
              )}
            </div>
          );
        })}

        {/* Next Button */}
        <div>
          {currentPage < totalPages ? (
            <button
              onClick={() => onPageChange(currentPage + 1)}
              className="px-3 h-[32px]  rounded flex items-center"
              aria-label="Next page"
            >
              {ChevronRight}
            </button>
          ) : (
            <span className="px-3 h-[32px] bg-gray-300 rounded cursor-not-allowed flex items-center">
              {ChevronRight}
            </span>
          )}
        </div>
      </div>
    </nav>
  );
};
